import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const BoldTitle = styled.div`
  width: fit-content;
  font-size: 40px;
  font-family: Circular-Std-Bold;
  color: ${colors.titleStrongBlack};

  @media screen and (max-width: 550px) {
    font-size: 36px;
  }
`
export const SubTitle = styled.div`
  width: fit-content;
  font-size: 20px;
  color: ${colors.strongGray};

  @media screen and (max-width: 550px) {
    font-size: 16px;
  }
`
export const OriginCard = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  background-color: ${(props) => props.color[1]};
  color: ${(props) => props.color[0]};
  padding: 9px;
  width: fit-content;
`
export const OriginText = styled.text`
  text-wrap: nowrap;
  text-align: center;
  font-size: 15px;
`

export const Container = styled.div`
  height: 100%;
  width: 100%;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px;
`
export const ContentContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  flex-direction: column;
`
export const CardHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  flex-direction: column;
  padding-bottom: 40px;
  border-bottom: 1px solid ${colors.softGray};

`
export const Title = styled.div`
  width: fit-content;
  font-size: 20px;
  font-family: Circular-Std-Medium;
  color: ${colors.strongGray};
  margin-bottom: 5px;

  @media screen and (max-width: 550px) {
    font-size: 36px;
  }
`
export const BeneficiariesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
  
`
export const Content = styled.div`
  display: flex;
  margin-top: 10px;
  background-color: ${colors.grayBackground};
  border: 1px solid ${colors.softGray};
  padding: 15px;
  color: ${colors.strongGray};
  border-radius: 15px;
  font-size: 20px;
`
